<section *ngIf="isVisible || isLoading || loadError" class="task-assignments__container"
    [class.task-assignments__container--collapsed]="!isExpanded" aria-label="Assigned Work">
    <header class="task-assignments__header">
        <h3 class="task-assignments__title">
            <button class="task-assignments__toggle" type="button" [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'task-assignments-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()">
                <span>Assigned Work</span>
            </button>
        </h3>
        <div class="task-assignments__header-actions">
            <button *ngIf="canAddTask && isVisible" nz-button nzType="primary" nzSize="small" type="button"
                class="cb4-button task-assignments__add" [disabled]="isCheckingCreation"
                (click)="addTask(); $event.stopPropagation()">
                <i nz-icon nzType="plus" aria-hidden="true"></i>
                <span>Add Task</span>
            </button>
            <button class="task-assignments__collapse-toggle" type="button"
                [attr.aria-label]="isExpanded ? 'Collapse Assigned Work' : 'Expand Assigned Work'"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'task-assignments-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()">
                <span nz-icon [nzType]="isExpanded ? 'up' : 'down'" aria-hidden="true"></span>
            </button>
        </div>
    </header>

    <div class="task-assignments__content" [class.task-assignments__content--expanded]="isExpanded"
        [attr.aria-hidden]="!isExpanded">
        <div class="task-assignments__content-inner" [id]="'task-assignments-content-' + componentId"
            [attr.inert]="isExpanded ? null : ''">
            <p class="recent-activity__not-included">Visible to authorized assessment users.<br />This will not be included in the completed report.</p>
            <div *ngIf="isLoading" class="task-assignments__feedback" role="status">Loading assignments...</div>
            <div *ngIf="loadError" class="task-assignments__feedback task-assignments__feedback--error" role="alert">
                <span>{{ loadError }}</span>
                <button nz-button nzType="link" type="button" (click)="retry()">Retry</button>
            </div>

            <ng-container *ngIf="isVisible && !isLoading">
                <div *ngIf="creationError" class="task-assignments__feedback task-assignments__feedback--error" role="alert">
                    <span>{{ creationError }}</span>
                    <button nz-button nzType="link" type="button" (click)="retry()">Retry</button>
                </div>
                <p *ngIf="!total" class="task-assignments__empty">{{ scope === 'assessment' ? 'No assignments for this assessment.' : 'No assignments for this requirement.' }}</p>
                <div *ngIf="isExpanded && workItems.length" class="task-assignments__list">
                    <button *ngFor="let item of workItems; trackBy: trackWorkItem" nz-button nzType="default" type="button"
                        class="task-assignments__row" (click)="openItem(item)"
                        [attr.aria-label]="item.kind === 'task' ? 'Open task ' + item.task.description : 'Open evidence ' + item.evidence.evidenceName">
                        <span class="task-assignments__description">
                            {{ item.kind === 'task' ? item.task.description : item.evidence.evidenceName }}
                        </span>
                        <span class="task-assignments__metadata">
                            <span class="task-assignments__metadata-details">
                                <nz-tag [nzColor]="statusPresentation(item).tagColor">
                                    {{ statusPresentation(item).label }}
                                </nz-tag>
                                <ng-container *ngIf="item.task as task">
                                    <span *ngIf="task.dueDate" class="task-assignments__due"
                                        [class.task-assignments__due--overdue]="dueState(task.dueDate, task.status) === 'overdue'"
                                        [class.text-danger]="dueState(task.dueDate, task.status) === 'overdue'"
                                        [class.task-assignments__due--soon]="dueState(task.dueDate, task.status) === 'due_soon'"
                                        [class.text-warning]="dueState(task.dueDate, task.status) === 'due_soon'">
                                        <span class="task-assignments__due-label">Due:&nbsp;</span><time [attr.datetime]="task.dueDate">{{ task.dueDate | date: 'd MMMM yyyy' }}</time>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="item.evidence as evidence">
                                    <span *ngIf="evidence.dueDate" class="task-assignments__due"
                                        [class.task-assignments__due--overdue]="evidenceDueState(evidence.dueDate, evidence.status) === 'overdue'"
                                        [class.text-danger]="evidenceDueState(evidence.dueDate, evidence.status) === 'overdue'"
                                        [class.task-assignments__due--soon]="evidenceDueState(evidence.dueDate, evidence.status) === 'due_soon'"
                                        [class.text-warning]="evidenceDueState(evidence.dueDate, evidence.status) === 'due_soon'">
                                        <span class="task-assignments__due-label">Due:&nbsp;</span><time [attr.datetime]="evidence.dueDate">{{ evidence.dueDate | date: 'd MMMM yyyy' }}</time>
                                    </span>
                                </ng-container>
                                <span class="task-assignments__assignees">Assigned To: {{ assigneeSummary(item) }}</span>
                            </span>
                            <i nz-icon nzType="right" aria-hidden="true" class="task-assignments__chevron"></i>
                        </span>
                    </button>
                </div>

                <footer *ngIf="scope === 'assessment' || total > pageSize" class="task-assignments__footer">
                    <div *ngIf="scope === 'assessment'" class="task-assignments__footer-actions">
                        <button nz-button nzType="primary" nzSize="small" type="button"
                            class="cb4-button task-assignments__required-evidence"
                            (click)="openRequiredEvidence()">
                            <i nz-icon nzType="file-search" aria-hidden="true"></i> Manage Required Evidence
                        </button>
                        <button nz-button nzType="primary" nzSize="small" type="button"
                            class="task-assignments__see-all cb4-button" (click)="openAll()">
                            <i nz-icon nzType="unordered-list" aria-hidden="true"></i> Manage Assigned Tasks
                        </button>
                    </div>
                    <nz-pagination *ngIf="total > pageSize" [nzPageIndex]="pageIndex" [nzPageSize]="pageSize"
                        [nzTotal]="total" [nzShowSizeChanger]="false" class="task-assignments__pagination"
                        (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
                </footer>
            </ng-container>
        </div>
    </div>
</section>
